import { IStakingOverview } from "../../common/interfaces/staking.interface";
import { get } from "../utilities/http";
import { STAKING_OVERVIEW } from "../utilities/urls";

export function getStakingOverview(): Promise<IStakingOverview> {
  return get(STAKING_OVERVIEW);
}
